// Chaves de cache (react-query) do sino de conversas do WhatsApp. Arquivo próprio porque são usadas pelo Layout
// (polling do contador) e pelo WhatsAppInbox (invalida depois de marcar como lida) — e arquivo de componente só
// pode exportar componente (react-refresh).
export const INBOX_UNREAD_QUERY_KEY = ['whatsapp-inbox-unread'];
export const INBOX_CONVERSATIONS_QUERY_KEY = ['whatsapp-conversations'];
